import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledCard = styled.div`
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border: 2px solid ${(props) => props.theme.borderLight};
   border-radius: 16px;
   width: 100%;
   min-width: 190px;
   flex-grow: 1;
   flex-basis: 33%;
`;
StyledCard.displayName = 'StyledCard';

export const StyledCardUpdatedData = styled.div`
   ${basicSmallTextStyle}
   color: ${(props) => props.theme.border};
   text-align: right;
`;
StyledCardUpdatedData.displayName = 'StyledCardUpdatedData';
